import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import {
  ItemTextContainer,
  ListTextContainer,
  ListIconContainer,
  SearchContainer,
  NotFoundWrapper,
} from "components/common/Input/style";
import { LabelsContext, ThemeContext } from "helpers/contexts";
import { SIZE, VARIENT } from "constant";
import { isMobile } from "components/globals";
import Text from "components/common/Text";
import debounce from "lodash.debounce";
import { boldSearchMatch } from "./HelperFunctions";
import List, {
  ListItem,
  ListItemHeader,
  ListItemIcon,
  ListItemText,
} from "components/common/List";
import { SearchInput } from "..";

MobileOptionList.propTypes = {
  iconClick: PropTypes.func,
  isSearchable: PropTypes.bool,
  onOptionClick: PropTypes.func,
  selectedValue: PropTypes.object,
  options: PropTypes.array.isRequired,
};

function MobileOptionList(props) {
  const theme = useContext(ThemeContext);
  const labels = useContext(LabelsContext);
  const listBorderColor = theme.colors.gray.gray200;
  const [searchValue, setSearchValue] = useState("");
  const [hasSearchResultsOptions, setHasSearchResultsOptions] = useState(true);
  const isMobileMode = isMobile();
  const itemListTextSize = isMobileMode ? SIZE.large : SIZE.xs;
  const headerPadding = isMobileMode ? "16px" : "20px";
  const showNotFoundMsg = !hasSearchResultsOptions && props.isSearchable;
  const searchInputPadding = "8px 0 8px 3px";

  const handleSearchInput = debounce((value) => {
    setSearchValue(value);
    const optionsMatch = props.options.filter((option) =>
      option.label?.includes(value)
    );

    if (optionsMatch.length > 0) {
      setHasSearchResultsOptions(true);
    } else if (optionsMatch.length === 0 && hasSearchResultsOptions) {
      setHasSearchResultsOptions(false);
    }
  }, 300);

  function handleSearchInputClearClick() {
    setHasSearchResultsOptions(true);
    setSearchValue("");
  }

  return (
    <>
      <List>
        <ListItemHeader borderColor={listBorderColor} padding={"0"}>
          <ListTextContainer padding={headerPadding}>
            <ListItemText size={SIZE._3xl} primary={props.listLabel} />
          </ListTextContainer>
          <ListIconContainer>
            <ListItemIcon
              onClick={props.iconClick}
              iconSize={SIZE.large}
              color={theme.colors.gray.aluminium}
              name="x-default"
            />
          </ListIconContainer>
        </ListItemHeader>
        {props.isSearchable && (
          <SearchContainer borderColor={theme.colors.gray.gray200}>
            <ListItemHeader padding={searchInputPadding}>
              <SearchInput
                showIcon
                value={searchValue}
                placeholder={labels.selectInput.search}
                onSearch={handleSearchInput}
                variant={VARIENT.empty}
                isQuickSearch
                size={SIZE.large}
                width={"100%"}
                lineHeight={false}
                onClearInput={handleSearchInputClearClick}
              ></SearchInput>
            </ListItemHeader>
          </SearchContainer>
        )}
        {Object.keys(props.options).map((key, index) => {
          const isOptionContainsInput = props.options[key].label
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase());

          if (isOptionContainsInput) {
            return (
              <ListItem
                isSelected={props.selectedValue === props.options[index]}
                borderColor={listBorderColor}
                padding={0}
                onClick={() => props.onOptionClick(props.options[index])}
                key={key}
              >
                <ItemTextContainer>
                  <ListItemText
                    size={itemListTextSize}
                    primary={boldSearchMatch(
                      props.options[key].label,
                      searchValue
                    )}
                  />
                </ItemTextContainer>
              </ListItem>
            );
          } else {
            return <></>;
          }
        })}
      </List>
      <NotFoundWrapper display={showNotFoundMsg ? "flex" : "none"}>
        <Text color={theme.colors.gray.aluminium}>
          {labels.selectInput.notFound}
        </Text>
      </NotFoundWrapper>
    </>
  );
}

export default MobileOptionList;
